import React, { useState, useContext } from 'react';
import CVstaffs from './CV/CVstaffs';
import StaffInfo from './CV/StaffInfo';
import ChangeStatus from './CV/ChangeStatus';
import Status from './CV/Charts/Status';
import StaffAllotted from './CV/Charts/StaffAllotted';
import { AuthContext } from "../../Auth/AuthContext";
import DueStudents from './CV/DueStudents';

function CVServices() {
    const { auth } = useContext(AuthContext);
    const [activeTab, setActiveTab] = useState('staffs');
    return (
        <div>
            <div style={{ display: 'flex', flexDirection: 'column', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap', justifyContent: 'center', alignItems: 'center', marginBottom: '10px' }}>
                    <div style={{ maxWidth: '350px' }} className='chart-container'>
                        <Status />
                    </div>
                    <div style={{ maxWidth: '350px' }} className='chart-container'>
                        <StaffAllotted />
                    </div>
                </div>
                <div style={{ display: 'flex', flexDirection: 'row', flexWrap: 'wrap' }}>
                    <div className="tabs">
                        <button
                            className={`tab-btn ${activeTab === 'staffs' ? 'active' : ''}`}
                            onClick={() => setActiveTab('staffs')}
                        >
                            Staff
                        </button>
                        <button
                            className={`tab-btn ${activeTab === 'staff_info' ? 'active' : ''}`}
                            onClick={() => setActiveTab('staff_info')}
                        >
                            Staff Info
                        </button>
                        <button
                            className={`tab-btn ${activeTab === 'change_status' ? 'active' : ''}`}
                            onClick={() => setActiveTab('change_status')}
                        >
                            Change Status
                        </button>
                        {auth.user.accesslvl === "M" && (
                            <button
                                className={`tab-btn ${activeTab === 'due_students' ? 'active' : ''}`}
                                onClick={() => setActiveTab('due_students')}
                            >
                                Insert Due Payment Students
                            </button>
                        )
                        }
                    </div>
                </div>
                {activeTab === 'staffs' && (
                    <div className='app-service-container'>
                        <CVstaffs />
                    </div>
                )}
                {activeTab === 'staff_info' && (
                    <div className='app-service-container'>
                        <StaffInfo />
                    </div>
                )}
                {activeTab === 'change_status' && (
                    <div className='app-service-container'>
                        <ChangeStatus />
                    </div>
                )}
                {activeTab === 'due_students' && auth.user.accesslvl === "M" && (
                    <div className='app-service-container'>
                        <DueStudents />
                    </div>
                )}
            </div>
            <div>
                {/* <div className='service-container'>
                    <HandleSchedule />
                </div> */}
            </div>
        </div>
    )
}

export default CVServices;